import { Search } from '@material-ui/icons'
import { InputAdornment, TextField, TextFieldProps } from '@mui/material'
import React, { ChangeEvent, useEffect, useState } from 'react'
import { useDebounce } from 'usehooks-ts'
import { Content } from './styles'

type IInputSearch = Omit<TextFieldProps, 'onChange'> & {
  onChange: (search: string) => void
}

export function InputSearch(props: IInputSearch) {
  const { onChange, ...propsTextField } = props
  const [value, setValue] = useState<string>('')
  const debouncedValue = useDebounce<string>(value, 200)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value)
  }

  useEffect(() => {
    if (props.onChange) props.onChange(value)
  }, [debouncedValue])

  return (
    <Content>
      <TextField
        {...propsTextField}
        onChange={handleChange}
        sx={{ m: 1 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <Search />
            </InputAdornment>
          ),
        }}
      />
    </Content>
  )
}
